import { HttpErrorResponse } from '@angular/common/http';
import { PreAuthorizedDebitMode } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const MakePaymentCoreComponentActions = createActionGroup({
  source: 'Make Payment Core Component',
  events: {
    'Load Pre Authorized Debit Mode Success': props<{
      payload: PreAuthorizedDebitMode;
    }>(),
    'Load Pre Authorized Debit Mode Error': props<{
      error: HttpErrorResponse;
    }>(),
  },
});
